import Home from '@/components/page/Home/Home';
import Audit from '@/components/page/Home/Audit';
import Account from '@/components/page/Account/Account';
import Motors from '@/components/page/Motors';
import Selection from '@/components/page/Selection';
import MotorDetails from '@/components/page/Selection/MotorDetails';
import Site from '@/components/page/Site';
import Status from '@/components/page/Status';
import Help from '@/components/page/Help';
import Motor from '@/components/page/Motors/Motor';

export default [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/motors',
        name: 'Motors',
        component: Motors
    },
    {
        path: '/site/motor/:motorUid?',
        name: 'Motor',
        component: Motor
    },
    {
        path: '/selection/:auditUid',
        name: 'Selection',
        component: Selection
    },
    {
        path: '/selection/details/:motorUid',
        name: 'MotorDetails',
        component: MotorDetails
    },
    {
        path: '/site/:siteUid?',
        name: 'Site',
        component: Site
    },
    {
        path: '/help',
        name: 'Help',
        component: Help
    },
    {
        path: '/audit/:auditUid?',
        name: 'Audit',
        component: Audit
    },
    {
        path: '/account',
        name: 'Account',
        component: Account
    },
    // Should be disabled if window.config.autonome_motor_select is true
    {
        path: '/status',
        name: 'Status',
        component: Status
    },


];



// WEBPACK FOOTER //
// ./src/router/routes.js